import { ROUTE_CHILD_REGISTER, ROUTE_CHILD_REGISTER_ADD, ROUTE_CHILD_REGISTER_EDIT } from 'config/routes';
import React, { FC, useContext, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { LocaleContext } from 'context/locale';
import { ChildRegisterList } from 'views/Panel/ChildRegister/ChildRegisterList/ChildRegisterList.view';
import { ChildRegisterAdd } from 'views/Panel/ChildRegister/ChildRegisterAdd/ChildRegisterAdd.view';
import { ChildRegisterEdit } from 'views/Panel/ChildRegister/ChildRegisterEdit/ChildRegisterEdit.view';

export const ChildRegisterView: FC = () => {
  const { trans } = useContext(LocaleContext);

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.CHILD-REGISTER.CHILD-REGISTER')} to={ROUTE_CHILD_REGISTER} />

      <Routes>
        <Route path={relativePath(ROUTE_CHILD_REGISTER_ADD, ROUTE_CHILD_REGISTER)} element={<ChildRegisterAdd />} />
        <Route path={relativePath(ROUTE_CHILD_REGISTER_EDIT, ROUTE_CHILD_REGISTER)} element={<ChildRegisterEdit />} />
        <Route path={relativePath(ROUTE_CHILD_REGISTER, ROUTE_CHILD_REGISTER)} element={<ChildRegisterList />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
